export default {
  'searchParts.label.automaker': 'Automaker',
  'searchParts.label.model': 'Model',
  'searchParts.label.searchType': 'Search Type',

  'searchParts.column.description': 'Description',
  'searchParts.column.barcode': 'Bar code',
  'searchParts.column.manufacturerCode': 'Manufacturer Code',
  'searchParts.column.internalcode': 'Internal code',

  'searchParts.button.filter': 'Filter',
  'searchParts.button.clean': 'Clean',
  'searchParts.button.select': 'Select',

  'searchParts.option.global': 'Global',
  'searchParts.option.free': 'By field - Free',
  'searchParts.option.specify': 'By field – Specify',
};
